import TierProductCard from './TierProductCard';
import TierProductCardContainer from './TierProductCard.container';
export default TierProductCardContainer(TierProductCard);
